import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

/**
 * Environment-gated logging service.
 *
 * Usage:
 *   private logger = inject(LoggingService);
 *   this.logger.log('Loaded rules', rules);
 *   this.logger.warn('Slow response', duration);
 *   this.logger.error('API failed', err);
 *
 * In production, no output is written to the console.
 * A remote hook (e.g. Sentry / Datadog) can be wired in
 * the `error()` method without touching any call site.
 */
@Injectable({ providedIn: 'root' })
export class LoggingService {
  private readonly isProd = environment.production;

  log(message: string, ...data: unknown[]): void {
    if (!this.isProd) {
      // eslint-disable-next-line no-console
      console.log(`[LOG] ${message}`, ...data);
    }
  }

  info(message: string, ...data: unknown[]): void {
    if (!this.isProd) {
      // eslint-disable-next-line no-console
      console.info(`[INFO] ${message}`, ...data);
    }
  }

  warn(message: string, ...data: unknown[]): void {
    if (!this.isProd) {
      // eslint-disable-next-line no-console
      console.warn(`[WARN] ${message}`, ...data);
    }
  }

  error(message: string, ...data: unknown[]): void {
    if (!this.isProd) {
      // eslint-disable-next-line no-console
      console.error(`[ERROR] ${message}`, ...data);
    }
    // TODO: forward to remote error tracker (Sentry / Datadog) in production
    // if (this.isProd) { Sentry.captureException(data[0]); }
  }
}
